module.exports = __webpack_public_path__ + "img/20190701155515280.083e29a6.png";